// extracted by mini-css-extract-plugin
export var cardContainer = "_ph-0";
export var cardHeader = "_ph-2";
export var collapsedState = "_ph-3";
export var dragHandle = "_ph-5";
export var dragHandleIcon = "_ph-6";
export var dragging = "_ph-1";
export var titleArea = "_ph-4";